import { Component, OnInit, Input} from '@angular/core';
import * as d3 from "d3";
import d3Tip from "d3-tip"
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss']
})
export class BarComponent implements OnInit {
   private dataObject: any = [];
   private svg;
   private g;
   private margin = { top: 20, right: 20, bottom: 50, left: 40 };
   private width;
   private height;

   @Input() vizName: string;
   @Input() vizInfo: object;
   @Input() dataInput: any;
   @Input() graphOptions: any;
   @Input() filterX: any;
   @Input() graph: any = {};
   @Input() containerId: any;

  constructor() { }

  async ngOnInit() {
    this.drawBars(await this.getData(this.vizName), this.graph);
    d3.select(window).on('resize', this.resize);
  }

  private async getData(vizName) {
    let data: any = [];

    // console.log("DATA =====> ", this.dataInput);
    // console.log("GRAPH OPTS => ", this.graphOptions);
    data = this.dataInput;

    this.dataObject = data;

    return data;
  }

  public createSvg(): void {}

  public drawBars(data: any[], options): void {
    this.svg = d3.select(`svg#${this.containerId}`)
      .attr("class", `barchart-${this.containerId}`);

    let bounds = this.svg.node().getBoundingClientRect();

    this.width = bounds.width - this.margin.left - this.margin.right,
    this.height = bounds.height - this.margin.top - this.margin.bottom;

    this.g = d3.select(`.barchart-${this.containerId}`)
      .append("g")
      .attr("transform", `translate(${this.margin.left}, ${this.margin.right})`);

    // Create the X-axis band scale
    const x = d3.scaleBand()
      .range([0, this.width])
      .domain(data.map(d => d[this.filterX]))
      .padding(0.3);

    let xAxis = this.g.append("g");

    xAxis.call(d3.axisBottom(x).tickValues(x.domain().filter((d, i) => !(1%10))));
    xAxis.attr("transform", `translate(${0}, ${this.height})`);
    xAxis.attr("class", "axis_text");
    xAxis.selectAll("text")
      .attr("transform", "translate(-10,10)rotate(-45)")
      .style("text-anchor", "end");

    // Create the Y-axis band scale
    const y = d3.scaleLinear()
      .domain(d3.extent(data, d => d[this.graphOptions]))
      .range([this.height, 0]);

    // Draw the Y-axis on the DOM
    this.g.append("g")
      .attr("class", "axis_text")
      .call(d3.axisLeft(y).ticks(5))
      // .call(xAxis)

      let controller = this;

    let tip = d3Tip()
      .attr('class', 'd3-tip')
      .offset([-10, 0])
      .html(function (h) {
        return `
          <span>Total: ${h[controller.graphOptions]}</span><br>
          <span>Fecha: ${h[controller.filterX] ? h[controller.filterX].split("T")[0] : h[controller.filterX] }</span>
        `;
      });

    this.svg.call(tip);

    // Create and fill the bars
    this.g.selectAll("bars")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", d => x(d[this.filterX]))
      .attr("y", d => y(d[this.graphOptions]))
      .attr("width", x.bandwidth())
      .attr("height", (d) => this.height - y(d[this.graphOptions]))
      .attr("fill", options.style.fill)
      .on("mouseover", function (event, d) {
        d3.select(this).attr("fill", options.style_mouseover.fill);
        tip.show(event, this);
      })
      .on("mouseout", function(event, d) {
        d3.select(this).attr("fill", options.style.fill);
        tip.hide(event,this);
      });
  }

  private resize() {
    console.log("estoy en resize");
    this.createSvg();
  };

  private logData(d: any) {
      console.log(d);
  }
}
